export function error (message) {
  return {
    type: 'NOTIFICATION_MESSAGE',
    level: 'error',
    message,
  }
}

export function success (message) {
  return {
    type: 'NOTIFICATION_MESSAGE',
    level: 'success',
    message,
  }
}

export function reset () {
  return {
    type: 'RESET_NOTIFICATION',
  }
}



// WEBPACK FOOTER //
// ./src/store/Notification/actions.js